import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  clearIntervalAsync,
  setIntervalAsync,
} from 'set-interval-async/dynamic'
// import BetPlacing from "../../BetPlacing/BetPlacing";
import CardsInfo from '../helpers/CardsInfo/CardsInfo'
import { GET_INPLAY_POPULAR_INTERVAL } from '../../../config/app.config'
import LastResults from '../helpers/LastResults/LastResults'
import { connectAndarBahar } from './AndarBahar.connect'
import './AndarBahar.scss'

const AndarBahar = ({
  sportEvent,
  betPlacing,
  actions,
  exchangeGames,
  exposure,
  activeTab,
  headerHeight,
  auth,
  elementsParams,
}) => {
  const dataOdd = sportEvent.sportData
  const { eventId } = useParams()

  // window width
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth
  // end window width

  //get price
  const getMarketPrice = (marketIndex, runnersIndex) => {
    if (
      dataOdd &&
      dataOdd[marketIndex] &&
      dataOdd[marketIndex].runners[runnersIndex] &&
      dataOdd[marketIndex].runners[runnersIndex].back[0] &&
      dataOdd[marketIndex].runners[runnersIndex].back[0].price
    ) {
      return dataOdd[marketIndex].runners[runnersIndex].back[0].price
    }
  }
  //end get price

  // get exposure
  const getExposure = (marketIndex, runnerIndex) => {
    if (auth) {
      const id =
        sportEvent.sportData[marketIndex] &&
        sportEvent.sportData[marketIndex].runners[runnerIndex] &&
        sportEvent.sportData[marketIndex].runners[runnerIndex].id
      let objFinder =
        exposure?.pnlBySelection[
          Object.keys(exposure?.pnlBySelection).filter((item) =>
            item.includes(id)
          )
        ]?.pnl
      // const objFinder = 200;
      return (
        <div
          className={
            objFinder > 0
              ? 'andar-bahar-exposure-box-modern andar-bahar-exposure-modern--pos'
              : 'andar-bahar-exposure-box-modern andar-bahar-exposure-modern--neg'
          }
        >
          {objFinder}
        </div>
      )
    } else return
  }
  // end get exposure
  // Show betslip
  // const renderBetPlacing = () => {
  //     if (betPlacing.runner && width < 1024) {
  //         return <BetPlacing  headerHeight={headerHeight}/>;
  //     }
  //     return null;
  // };
  // End Show betslip
  // Bet placing
  const select = (dataOdd, item, isBack) => {
    const runner = { name: item.name, id: item.id }
    const oddData = isBack
      ? { ...item.back[0], runner }
      : { ...item.lay[0], runner }
    const marketId = dataOdd && dataOdd.id
    const runnerId = oddData && oddData.runner && oddData.runner.id
    if (!marketId || !runnerId) return
    actions.setMarket(marketId)
    actions.setRunner(runnerId)
    actions.setRunnerName(oddData && oddData.runner && oddData.runner.name)
    actions.setEventName(dataOdd && dataOdd.event && dataOdd.event.name)
    actions.setIsBack(isBack)
    actions.setPrice(oddData && oddData.price)
    actions.setPriceActual(oddData && oddData.price)
    actions.setDelay(dataOdd && dataOdd.betDelay)
    actions.setMtype(dataOdd && dataOdd.mtype)
    actions.setBtype(dataOdd && dataOdd.btype)
    actions.setLine(oddData && oddData.line)
    actions.setFromOneClick(false)
    actions.setStake(null)

    actions
      .requestBetPlacingStart(marketId, runnerId)
      .then((response) => {})
      .catch((err) => console.error('err = ', err))
  }
  const oddPush = (marketIndex, runnerIndex, isBack = true) => {
    return dataOdd[marketIndex].isBettable
      ? select(
          dataOdd[marketIndex],
          dataOdd[marketIndex]?.runners[runnerIndex],
          isBack
        )
      : null
  }
  // End Bet placing
  // lock market
  const resultStatus = (marketIndex, runner) => {
    if (
      exchangeGames &&
      exchangeGames[marketIndex]?.marketRunner[runner]?.status === 'WINNER'
    ) {
      return 'lock-ui winner'
    }
    return !dataOdd[marketIndex].isBettable && 'lock-ui'
  }
  // end lock market

  useEffect(() => {
    const timer = setIntervalAsync(async () => {
      await actions
        .requestExchangeGames(eventId)
        .catch((e) => console.error('requestInplayPopular error = ', e))
    }, GET_INPLAY_POPULAR_INTERVAL)
    return () => clearIntervalAsync(timer)
  }, [])

  return (
    <>
      <CardsInfo />
      <div
        className={`andar-bahar ${eventId === '87565' ? 'virtual' : ''} ${
          activeTab === 0 ? 'fullHeight' : ''
        }`}
      >
        {/* <>{width < 1024 ? renderBetPlacing() : ""}</> */}
        <div className="andar-bahar-table">
          <div className="andar-bahar-table__body">
            <div className="andar-bahar-table__body-players">
              <div className="andar-bahar-table__body-players-header">
                <span>1st Card Bahar 25%</span>
              </div>
              <div className="andar-bahar-table__body-player-row">
                <div
                  className={`andar-bahar-table__body-player-wrapper ${resultStatus(
                    0,
                    0
                  )}`}
                  onClick={() => {
                    oddPush(0, 0)
                  }}
                >
                  <div className="andar-bahar-table__body-player-title">
                    <span className="andar-bahar-table__body-player-info-text">
                      Bahar
                    </span>
                    {getExposure(0, 0)}
                  </div>
                  <div className="andar-bahar-table__body-player-price">
                    <span className="andar-bahar-table__body-player-info-text bold">
                      {getMarketPrice(0, 0)}
                    </span>
                  </div>
                </div>
                <div
                  className={`andar-bahar-table__body-player-wrapper ${resultStatus(
                    0,
                    1
                  )}`}
                  onClick={() => {
                    oddPush(0, 1)
                  }}
                >
                  <div className="andar-bahar-table__body-player-title">
                    <span className="andar-bahar-table__body-player-info-text">
                      Andar
                    </span>
                    {getExposure(0, 1)}
                  </div>
                  <div className="andar-bahar-table__body-player-price">
                    <span className="andar-bahar-table__body-player-info-text bold">
                      {getMarketPrice(0, 1)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LastResults />
      </div>
    </>
  )
}

export default connectAndarBahar()(AndarBahar)
